import React from "react";
import { Card, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { DefaultLayout } from "@components/Layouts";
import { url_reverse } from "@components/Utils";

export default function EventNewsletterHistoryScreen() {
    const { t } = useTranslation();
    const { event_slug } = useParams();
    const apiUrl = url_reverse("api:event:newsletter_history", { event_slug });
    const { apiData } = useAppApi(apiUrl);

    if (!apiData) return;
    const header = (
        <>
            <Link to={url_reverse("admin:event:send_newsletter", { event_slug })}>{t("Рассылка")}</Link>
            <span> – </span>
            {t("История рассылок")}
        </>
    );
    return (
        <DefaultLayout>
            <Card>
                <Card.Header>{header}</Card.Header>
                <Card.Body>
                    <Table responsive className="dmg-table">
                        <thead>
                            <tr>
                                <th>{t("Тип Рассылки")}</th>
                                <th>{t("Дата отправления")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {apiData?.object_list.map((el) => {
                                return (
                                    <tr key={el.id}>
                                        <td>
                                            <Link
                                                to={url_reverse("admin:event:newsletter_history:item", {
                                                    event_slug,
                                                    newsletter_id: el.id,
                                                })}
                                            >
                                                {apiData?.newsletter_types[el.type]}
                                            </Link>
                                        </td>
                                        <td>{el.date}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </DefaultLayout>
    );
}
